import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OpeningLead() {
  return <section className="py-20 px-4 bg-white/50" data-id="element-86">
      <div className="max-w-2xl mx-auto text-lg md:text-xl leading-relaxed text-stone-700 space-y-8" data-id="element-87">
        <FadeIn data-id="element-88">
          <p className="font-medium text-stone-900" data-id="element-89">
            Hay un tipo de cansancio que no se quita durmiendo.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-90">
          <p data-id="element-91">Es el cansancio de vivir con la mente prendida todo el día.</p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-92">
          <p data-id="element-93">
            El de recordar mil cosas.
            <br data-id="element-94" />
            El de salir tarde, correr, resolver, pedir perdón, volver a correr.
            <br data-id="element-95" />Y terminar la noche pensando:{' '}
            <span className="italic text-stone-900" data-id="element-96">
              "¿Por qué siento que no hice nada… si no paré?"
            </span>
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-97">
          <div className="pl-6 border-l-4 border-[#C75B3F]/30 py-2 my-8" data-id="element-98">
            <p data-id="element-99">
              Si eres mamá inmigrante en USA y estás criando sin red, no estás
              exagerando.
              <br data-id="element-100" />
              <span className="font-semibold text-[#C75B3F]" data-id="element-101">
                Estás sosteniendo una vida grande con un sistema demasiado
                frágil.
              </span>
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-102">
          <p className="text-center font-medium text-stone-900 mt-12" data-id="element-103">
            Este PDF existe por una sola razón:
            <br data-id="element-104" />
            <span className="text-2xl md:text-3xl font-bold text-[#C75B3F] mt-4 block" data-id="element-105">
              para que tu semana deje de depender de fuerza de voluntad… y
              empiece a sostenerse con estructura.
            </span>
          </p>
        </FadeIn>
      </div>
    </section>;
}